package one.healthium.log_food.ui.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.value.Value
import one.healthium.log_food.ui.navigation.add_food.AddFoodComponent
import one.healthium.log_food.ui.navigation.find_food.FindFoodComponent
import one.healthium.profile.ui.food.models.FoodUiModel

interface LogFoodComponent : ViewModelStoreOwner {

    val stack: Value<ChildStack<*, Child>>
    val taskId: String?
    val food: FoodUiModel?

    fun onCloseClicked()

    sealed class Child {
        class FindFood(val component: FindFoodComponent) : Child()
        class AddFood(val component: AddFoodComponent) : Child()
    }
}